(function($){
    $.fn.extend({
        rotaterator: function(options) {

            var defaults = {
                fadeSpeed: 500,
                pauseSpeed: 100,
                child:null
            };

            var options = $.extend(defaults, options);

            return this.each(function() {
                    var o =options;
                    var obj = $(this);
                    var items = $(obj.children().not(':first'), obj);
                    items.each(function() {$(this).hide();})
                    if(!o.child){
                        var next = $(obj).children(':first');
                    }
                    else {
                        var next = o.child;
                    }
                    $(next).fadeIn(o.fadeSpeed, function() {
                        $(next).delay(o.pauseSpeed).fadeOut(o.fadeSpeed, function() {
                            var next = $(this).next();
                            if (next.length == 0){
                                    next = $(obj).children(':first');
                            }
                            $(obj).rotaterator({child : next, fadeSpeed : o.fadeSpeed, pauseSpeed : o.pauseSpeed});
                        })
                    });
            });
        }
    });
})(jQuery);

$(window).on('load', function () {
  if($('.announcement-bar__message-item').length > 1) {
    $('#announcementTexts').rotaterator({fadeSpeed:500, pauseSpeed:6000});
  }

  /* mega menu tabs */
  $('.js-tab-toggle').click(function() {
    $('.js-tab-toggle, .js-tab-content').removeClass('active');
    $(this).addClass('active');
    let targetId = $(this).data('target');
    $(targetId).addClass('active');
  });

  function videoId(button) {
    var $videoUrl = button.attr("data-video-url");
    if ($videoUrl !== undefined) {
      var $videoUrl = $videoUrl.toString();

      if ($videoUrl.indexOf("mp4") !== -1) {
        return (
          '<video loop playsinline autoplay controls><source src="' +
          $videoUrl +
          '" type="video/mp4"></video>'
        );
      }
      else if ($videoUrl.indexOf("m4v") !== -1) {
        return (
          '<video loop playsinline autoplay controls><source src="' +
          $videoUrl +
          '" type="video/mp4"></video>'
        );
      }
      else {
        alert(
          "The video assigned is not an mp4, remember to enter the correct complete video link .\n - MP4 https://server.com/file.mp4"
        );
        return false;
      }
    }
    else {
      alert("No video assigned.");
      return false;
    }
  }

  /* Watch video button opens video */
  if($('.js-video-popup').length) {
    $('.js-video-popup').on('click',  function (e) {
      e.preventDefault();
      var $theVideo = videoId($(this));
      if ($theVideo) {
        $('body').append('<div class="active" id="video-wrap"><span class="video-overlay"></span><div class="video-container">' +
          $theVideo +
          '</div><button class="close-video"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path></svg></button></div>'
        ).addClass("active");
      }
    });
    $(document).on('click', '.close-video, .video-overlay', function () {
      $('#video-wrap').remove();
    });
  }


  const $window = $(window),
	$body = $('body'),
  $section = $('.shopify-section');

  function updateSectionColorOnScroll2() {
    var scroll = $window.scrollTop() + ($window.height() / 2);

    $section.each(function () {
      var $this = $(this);
      if ($this.position().top <= scroll && $this.position().top + $this.height() > scroll) {
        $body.css('background', $(this).find('[data-background-color]').data('background-color'));
      }
    });
  }
  updateSectionColorOnScroll2();

  if($('.template--page-landing-qr').length) {
    $(window).on('scroll', function() {
      updateSectionColorOnScroll2();
    });
  }
});

$(document).ready(function(){
  if($('.js-recipe-slider').length) {
    $('.js-recipe-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      mobileFirst: true,
      cssEase: 'linear',
      responsive: [
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      ]
    });
  }

  if($('.js-sub-info-slider').length) {
    $('.js-sub-info-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 500,
          settings: {
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false,
            arrows: true
          }
        },
        {
          breakpoint: 1025,
          settings: "unslick"
        }
      ]
    });
  }

});
